<template>
	<div ref="observerTarget">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'HideOnScroll',
	props: {
		targetId: {
			type: String,
			required: true
		}
	},
	mounted() {
		
		var component = this;
		setTimeout(function() {
			component.createObserver();
		},2000);
	},
	methods: {
		createObserver() {
			const targetElement = document.getElementById(this.targetId);
			if (!targetElement) {
				console.warn(`Element with ID '${this.targetId}' not found.`);
				return;
			}

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						//targetElement.style.display = 'none';
						targetElement.classList.add('hidden');
					} else {
						targetElement.classList.remove('hidden');
		
						//targetElement.style.display = 'block';
					}
				});
			});

			observer.observe(this.$refs.observerTarget);
		}
	}
};
</script>
